import { isCreditTransaction } from "@custom-types/credit-type-guards";
import { createSelector } from "@reduxjs/toolkit";
import { creditTransactionAdapter } from "@store/credit-transactions/credit-transactions-slice";
/** Returns all the credit transactions */
export const creditTransactionsSelector = createSelector(state => state.creditTransactions, creditTransactionsState => {
  const creditTransactions = creditTransactionAdapter.getSelectors().selectAll(creditTransactionsState);
  return creditTransactions.filter(isCreditTransaction);
});

/**
 * Returns the fetching properties of the credit transactions slice.
 */
export const fetchingTransactionsFlagsSelector = createSelector(state => state.creditTransactions, creditTransactionsState => {
  return creditTransactionsState.fetching;
});

/**
 * Returns the pagination properties of the credit transactions.
 */
export const transactionPaginationSelector = createSelector(state => state.creditTransactions, creditTransactionsState => {
  return creditTransactionsState.pagination;
});